import { IPatchBodyWagesParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyWages/patchBodyWages.type';
import { patchBodyWagesQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyWages/patchBodyWagesQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const patchBodyWagesQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  IPatchBodyWagesParams
> => ({
  mutationKey: ['patchBodyWagesQueryOptions'],
  mutationFn: (params: IPatchBodyWagesParams) =>
    patchBodyWagesQueryFunction(params),
});
